var nb = require('../../nb');
var $ = nb.opts.$;
var util = require('../../util');
var seriesItem = require('../../view/header/SeriesItem');
module.exports = nb.define({
    parent: nb.model.List,
    mapping: {},
    method: {
        init: function () {
            this.set('itemType', seriesItem);
            var self = this;
            this.onChange('items', function (inEvent) {
                new Swiper('.header-series-swiper', {
                    slidesPerView: 5,
                    spaceBetween: 25,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next'
                })
            }, this);
            this.onChange('activeId', function (inEvent) {
                var time;
                var items = this.get('items');
                if (items && items.length > 0) {
                    this.setActiveIndex(inEvent.data);
                } else {
                    time = setInterval(function () {
                        self.setActiveIndex(inEvent.data, time);
                    }, 1000)
                }
            }, this)
        },
        setActiveIndex: function (inId, inTime) {
            var self = this;
            var items = this.get('items');
            if (items) {
                clearInterval(inTime);
                $.each(items, function (index, item) {
                    if (item.get('id') === inId) {
                        self.set('activeIndex', index);
                    }
                });
            }
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/header/SeriesList.js
// module id = 39
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32